import { render, staticRenderFns } from "./help-text.vue?vue&type=template&id=33e0a981&scoped=true"
import script from "./help-text.vue?vue&type=script&lang=js"
export * from "./help-text.vue?vue&type=script&lang=js"
import style0 from "./help-text.vue?vue&type=style&index=0&id=33e0a981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e0a981",
  null
  
)

export default component.exports